export default __webpack_public_path__ + "static/media/Pink-Cake-3.8d613536.jpg";